// SearchSidebar.jsx
import { useState, useEffect, useRef,useCallback } from "react";
import {
  Box,
  Slider,
  Typography,
  Chip,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  Button,Divider,
  Drawer, MenuItem, Select, InputLabel, FormControl, IconButton 
} from "@mui/material";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import DoneIcon from "@mui/icons-material/Done";
import debounce from "lodash/debounce";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PRICE_RANGE } from "./constants/properties";
import { formatIndianUnits } from "../helper/format";
import SearchBar2 from "./MyComps/searchBar2";
import {
  PROPERTY_TYPES,
  AMENITIES,
  FURNISHING_STATUS,
  BHK,
  BATHROOMS,
} from "./constants/properties";

export default function 
SearchSidebar({ purpose,onCloseParentDrawer, onFiltersChange,isMobile,  onFilterCountChange }) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const state = location.state || {};
  const navigate = useNavigate();
  const isSearchPage = location.pathname === "/search-results";
  const firstLoad = useRef(true);
const [filterCount, setFilterCount] = useState(0);
const [expandedFilters, setExpandedFilters] = useState({});
const[closeDrawer,serCloseDrawer] = useState(false);

const handleFilterCountChange = (count) => {
  setFilterCount(count);
};



  const sidebarFilterKeys = [
    "propertySubType",
    "bhk",
    "bathrooms",
    "amenities",
    "furnishingStatus",
    "availabilityStatus",
    "postedBy",
    "purchaseType",
    "availableFor",
  ];

 const [filters, setFilters] = useState({
  purpose,
  city: "",
  propertySubType: [],
  minPrice: 100000,
  maxPrice: 1000000000,
  minArea: 200,
  maxArea: 5000,
  bathrooms: [],
  bhk: [],
  amenities: [],
  furnishingStatus: [],
  availabilityStatus: [],
  postedBy: [],
  purchaseType: [],
  availableFor: [],
});

const handleCitySelect = (cities) => {
  setFilters((prev) => ({ ...prev, city: cities.join(",") }));

  // If you're on search page, update query param:
  if (isSearchPage) updateQueryParam("city", cities.join(","));

  

};

  useEffect(() => {
    const newFilters = { ...filters, purpose };
    searchParams.forEach((value, key) => {
      if (["minPrice", "maxPrice", "minArea", "maxArea"].includes(key)) {
        newFilters[key] = Number(value);
      
      } else {
        newFilters[key] = value.split(",");
      }
    });
    setFilters(newFilters);
  }, [searchParams, purpose]);

  useEffect(() => {
    if (state.propertySubType?.length > 0) {
      setFilters((prev) => ({
        ...prev,
        propertySubType: state.propertySubType,
      }));
    }
  }, [state]);

// const debouncedFilterChange = useCallback(
//   debounce((updatedFilters) => {
//     onFiltersChange?.(updatedFilters);
//   }, 700), // 500ms delay
//   [onFiltersChange]
// );

// useEffect(() => {
//   if (firstLoad.current) {
//     firstLoad.current = false;
//     return;
//   }
//   debouncedFilterChange(filters);
// }, [filters, debouncedFilterChange]);


  const updateQueryParam = (key, values) => {
    const newParams = new URLSearchParams(searchParams);
    if (Array.isArray(values)) {
      values.length ? newParams.set(key, values.join(",")) : newParams.delete(key);
    } else {
      values ? newParams.set(key, values) : newParams.delete(key);
    }
    setSearchParams(newParams);
  };

 const clearAllFilter = () => {
  const cleared = {
    ...filters,
    purpose,
    city: filters.city, // ✅ keep the city
    propertySubType: [],
    minPrice: 100000,
    maxPrice: 1000000000,
    minArea: 200,
    maxArea: 5000,
    bathrooms: [],
    bhk: [],
    amenities: [],
    furnishingStatus: [],
    availabilityStatus: [],
    postedBy: [],
    purchaseType: [],
    availableFor: [],
  };
  setFilters(cleared);

  const newParams = new URLSearchParams(searchParams);
  newParams.forEach((_, key) => {
    if (key !== "purpose" && key !== "city") newParams.delete(key); // ✅ don't remove city
  });
  setSearchParams(newParams);
};


  const clearFilter = (key) => {
    setFilters((prev) => ({ ...prev, [key]: Array.isArray(prev[key]) ? [] : "" }));
    updateQueryParam(key, []);
  };

  const handleChipSelect = (key, value) => {
    const updated = filters[key].includes(value)
      ? filters[key].filter((v) => v !== value)
      : [...filters[key], value];
    setFilters((prev) => ({ ...prev, [key]: updated }));
    if (isSearchPage) updateQueryParam(key, updated);

  };

  const handleRangeChange = ([minKey, maxKey], newValue) => {
    setFilters((prev) => ({
      ...prev,
      [minKey]: newValue[0],
      [maxKey]: newValue[1],
    }));
    updateQueryParam(minKey, newValue[0]);
    updateQueryParam(maxKey, newValue[1]);
  };

  const handleToggleSelect = (key) => (event, value) => {
    if (value === null) return;
    setFilters((prev) => ({ ...prev, [key]: [value] }));
    if (isSearchPage) updateQueryParam(key, [value]);
  };

  const handleShowProperties = () => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length) query.set(key, value.join(","));
      else if (typeof value === "string" && value.trim()) query.set(key, value);
      else if (!Array.isArray(value)) query.set(key, value);
    });
    navigate(`/search-results?${query.toString()}`);
    onCloseParentDrawer();
  };

const renderFilterSection = (title, key, options) => {
  const defaultVisible = 6; // Number of chips visible by default
  const isExpanded = expandedFilters[key] || false;
  const visibleOptions = isExpanded ? options : options.slice(0, defaultVisible);

  return (
    <Accordion defaultExpanded sx={{ border: "none", boxShadow: "none" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{  color: "gray", flexGrow: 1 }}>{title}</Typography>
        {filters[key].length > 0 && (
          <Button
            disableRipple
            onClick={(e) => {
              e.stopPropagation();
              clearFilter(key);
            }}
            sx={{ textTransform: "none", fontSize: "0.875rem", p: 0, mr: 1 }}
          >
            Clear
          </Button>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {visibleOptions.map((item) => (
            <Chip
              key={item}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  {filters[key].includes(item) ? <DoneIcon /> : <AddIcon />}
                  {item}
                </Box>
              }
              onClick={() => handleChipSelect(key, item)}
              sx={{
                borderRadius: 5,
                bgcolor: filters[key].includes(item) ? "#fdecea" : "transparent",
                color: filters[key].includes(item) ? "#e23744" : "inherit",
                border: `1px solid ${filters[key].includes(item) ? "#e23744" : "gray"}`,
                "&:hover": {
                  bgcolor: "#ffcccc",
                  color: "#e23744",
                  border: "1px solid #e23744",
                },
              }}
            />
          ))}
        </Stack>

        {options.length > defaultVisible && (
          <Button
            size="small"
            sx={{ mt: 1, textTransform: "none", pl: 0 }}
            onClick={() =>
              setExpandedFilters((prev) => ({ ...prev, [key]: !prev[key] }))
            }
          >
            {isExpanded ? "Show less" : `+${options.length - defaultVisible} more`}
          </Button>
        )}
      </AccordionDetails>
    </Accordion>
  );
};


const renderPriceRange = () => (
  <Accordion defaultExpanded sx={{ border: "none", boxShadow: "none" }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography sx={{ fontWeight: "bold", color: "gray", flexGrow: 1 }}>
        Price Range
      </Typography>
      {(filters.minPrice !== 100000 || filters.maxPrice !== 1000000000) && (
        <Button
          disableRipple
          onClick={(e) => {
            e.stopPropagation();
            handleRangeChange(["minPrice", "maxPrice"], [100000, 1000000000]);
          }}
          sx={{ textTransform: "none", fontSize: "0.875rem", p: 0, mr: 1 }}
        >
          Clear
        </Button>
      )}
    </AccordionSummary>
    <AccordionDetails>
      <Stack direction="row" gap={2} alignItems="center" sx={{ mb: 2 }}>
        <FormControl fullWidth 
        sx={{
    "& .MuiInputBase-root": {
      height: 36,
      fontSize: 14,
    },
  }}
        >
          <InputLabel id="min-price-label">Min Price</InputLabel>
          <Select
            labelId="min-price-label"
            value={filters.minPrice}
            label="Min Price"
            onChange={(e) =>
              handleRangeChange(["minPrice", "maxPrice"], [
                Number(e.target.value),
                filters.maxPrice,
              ])
            }
              MenuProps={{
    PaperProps: {
      style: {
        maxHeight: 200, 
      },
    },
  }}
          >
            {PRICE_RANGE.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth 
          sx={{
    "& .MuiInputBase-root": {
      height: 36,
      fontSize: 14,
    },
  }}
        >
          <InputLabel id="max-price-label">Max Price</InputLabel>
          <Select
            labelId="max-price-label"
            value={filters.maxPrice}
            label="Max Price"
            onChange={(e) =>
              handleRangeChange(["minPrice", "maxPrice"], [
                filters.minPrice,
                Number(e.target.value),
              ])
            }
              MenuProps={{
    PaperProps: {
      style: {
        maxHeight: 200, 
      },
    },
  }}
          >
            {PRICE_RANGE.filter((option) => option.value >= filters.minPrice).map(
              (option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </Stack>

      <Slider
        min={100000}
        max={1000000000}
        step={500000}
        value={[filters.minPrice, filters.maxPrice]}
        onChange={(e, newValue) =>
          handleRangeChange(["minPrice", "maxPrice"], newValue)
        }
        valueLabelDisplay="auto"
        sx={{
          "& .MuiSlider-thumb": {
            height: 16,
            width: 16,
            bgcolor: "#fff",
            border: "2px solid #e23744",
            "&:hover, &.Mui-focusVisible, &.Mui-active": {
              boxShadow: "0px 0px 0px 6px rgba(226, 55, 68, 0.16)",
            },
          },
          "& .MuiSlider-track": {
            height: 4,
          },
          "& .MuiSlider-rail": {
            height: 4,
          },
        }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2">₹{formatIndianUnits(filters.minPrice)}</Typography>
        <Typography variant="body2">₹{formatIndianUnits(filters.maxPrice)}</Typography>
      </Stack>
    </AccordionDetails>
  </Accordion>
);




useEffect(() => {
  const count = Object.values(filters).reduce((acc, val) => {
    if (Array.isArray(val)) return acc + val.length;
    return val ? acc + 1 : acc;
  }, 0);

  onFilterCountChange?.(count); // Safely call the callback if passed
}, [filters, onFilterCountChange]);

  return (
    <>
      {isMobile ? (
        <>
          <Box sx={{width:"100%",textAlign:"start",fontSize:"1.4rem"}}>
        <IconButton  onClick={onCloseParentDrawer} >
          <ArrowBackIcon/> {" "}
        </IconButton>
         Filter
          </Box>
          <Divider/>
          <Box sx={{ p: 2 }}>
             <Box sx={{my:2 ,width:"70%" ,height:"50px"}}>
             <Typography sx={{  color: "gray", flexGrow: 1 }}>Add Location</Typography>
              <SearchBar2 isInsideDrawer={true}   onSelectCities={handleCitySelect} />
              </Box>
              <Box sx={{mt:6}}>

            <Typography sx={{ color: "gray", flexGrow: 1 }}>You are looking to</Typography>

            <ToggleButtonGroup
              color="primary"
              exclusive
              value={filters.purpose?.[0] || ""}
              onChange={handleToggleSelect("purpose")}
            >
              <ToggleButton value="sale">Buy</ToggleButton>
              <ToggleButton value="rent/lease">Rent / Lease</ToggleButton>
            </ToggleButtonGroup>
                
              </Box>
             

            {renderFilterSection("BHK", "bhk", BHK)}
            {renderPriceRange()}
            {renderFilterSection("Bathrooms", "bathrooms", BATHROOMS)}
            {renderFilterSection("Furnishing", "furnishingStatus", FURNISHING_STATUS)}
            {renderFilterSection("Property Types", "propertySubType", PROPERTY_TYPES)}
            {renderFilterSection("Construction Status", "availabilityStatus", ["Ready to move", "Under Construction"])}
            {renderFilterSection("Posted By", "postedBy", ["Dealer", "Owner", "Builder"])}
            {renderFilterSection("Amenities", "amenities", AMENITIES)}

            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ borderRadius: 20, boxShadow: 0, mt: 2 }}
              onClick={handleShowProperties}
            >
              Show Properties
            </Button>
          </Box>
        </>
      ) : (
        <Box sx={{ p: 2, border: "1px solid #dbdbdb", borderRadius: 2, bgcolor: "white", mb: 4 }}>
          {sidebarFilterKeys.some((k) => filters[k]?.length > 0 || filters[k]) && (
            <>
              <Typography fontWeight="bold" mb={1} color="#3f5671">
                Applied Filters
              </Typography>
              <Stack direction="row" flexWrap="wrap" gap={1} mb={2}>
                {sidebarFilterKeys.flatMap((key) =>
                  Array.isArray(filters[key])
                    ? filters[key].map((val) => (
                        <Chip
                          key={`${key}-${val}`}
                          label={val}
                          onDelete={() => handleChipSelect(key, val)}
                          deleteIcon={<ClearIcon sx={{ color: "red" }} />}
                          sx={{
                            bgcolor: "#fdecea",
                            color: "#e23744",
                            border: "1px solid #e23744",
                            fontWeight: "bold",
                            borderRadius: 5,
                            "&:hover": { bgcolor: "#ffcccc" },
                          }}
                        />
                      ))
                    : filters[key]
                    ? [
                        <Chip
                          key={`${key}-${filters[key]}`}
                          label={filters[key]}
                          onDelete={() => clearFilter(key)}
                          deleteIcon={<ClearIcon sx={{ color: "red" }} />}
                          sx={{
                            bgcolor: "#fdecea",
                            color: "#e23744",
                            border: "1px solid #e23744",
                            fontWeight: "bold",
                            borderRadius: 5,
                            "&:hover": { bgcolor: "#ffcccc" },
                          }}
                        />,
                      ]
                    : []
                )}
                <Button onClick={clearAllFilter} sx={{ fontSize: "0.875rem", color: "#e23744" }}>
                  Clear all
                </Button>
              </Stack>
            </>
          )}

          {renderFilterSection("BHK", "bhk", BHK)}
          {renderPriceRange()}
          {renderFilterSection("Bathrooms", "bathrooms", BATHROOMS)}
          {renderFilterSection("Furnishing", "furnishingStatus", FURNISHING_STATUS)}
          {renderFilterSection("Property Types", "propertySubType", PROPERTY_TYPES)}
          {renderFilterSection("Construction Status", "availabilityStatus", ["Ready to move", "Under Construction"])}
          {renderFilterSection("Posted By", "postedBy", ["Dealer", "Owner", "Builder"])}
          {renderFilterSection("Amenities", "amenities", AMENITIES)}
        </Box>
      )}
    </>
  );
}
